import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Attachment } from '../../models/attachment.model';
import { SUPPORTED_EXTENSIONS, EXTENSION_ICON_MAP } from '../../configs/attachment.config';

@Component({
  selector: 'swisscom-sign-outlook-file-reader',
  templateUrl: './outlook-file-reader.component.html',
  styleUrls: ['./outlook-file-reader.component.scss'],
  standalone: false,
})
export class OutlookFileReaderComponent implements OnInit {
  public attachments: Attachment[] = [];
  public selectedAttachments = new Set<Attachment>();

  @Output() public selectedAttachmentsChange = new EventEmitter<Attachment[]>();

  public ngOnInit(): void {
    Office.onReady()
      .then(() => {
        this.getAttachments();
      })
      .catch((error) => {
        console.error('Error loading Office.js:', error);
      });
  }

  private getAttachments(): void {
    const item = Office.context.mailbox.item;
    if (!item) {
      return;
    }
    if (typeof item.getAttachmentsAsync !== 'function') {
      const attachments = item.attachments;
      if (attachments && attachments.length > 0) {
        const filteredAttachments = attachments.filter((att) => {
          const fileExtension = att.name.split('.').pop()?.toLowerCase();
          return SUPPORTED_EXTENSIONS.includes(fileExtension || '');
        });

        const convertedAttachments = filteredAttachments.map((att) => ({
          ...att,
          size: att.size ? Math.round(att.size / 1024) : undefined,
        }));
        this.attachments = convertedAttachments as Attachment[];
      }
    }
  }

  public getAttachmentIconClass(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    return EXTENSION_ICON_MAP[extension] || 'icon-document icon--s4';
  }

  public toggleAttachment(attachment: Attachment): void {
    if (this.selectedAttachments.has(attachment)) {
      this.selectedAttachments.delete(attachment);
    } else {
      this.selectedAttachments.add(attachment);
    }
    this.selectedAttachmentsChange.emit([...this.selectedAttachments]);
  }

  public isSelected(attachment: Attachment): boolean {
    return this.selectedAttachments.has(attachment);
  }
}
